import { useEffect } from 'react';
import { useUser } from '@/contexts/UserContext';

const TIMEOUT_MS = 15 * 60 * 1000;
const EVENTS = ['mousedown', 'keydown', 'scroll', 'touchstart'] as const;

export function useInactivityTracker() {
  const { logout } = useUser();

  useEffect(() => {
    let timer: ReturnType<typeof setTimeout>;

    const reset = () => {
      clearTimeout(timer);
      timer = setTimeout(() => {
        void logout();
      }, TIMEOUT_MS);
    };

    reset();
    EVENTS.forEach((evt) => window.addEventListener(evt, reset, { passive: true }));

    return () => {
      clearTimeout(timer);
      EVENTS.forEach((evt) => window.removeEventListener(evt, reset));
    };
  }, [logout]);
}
